<template>
  <!-- <div class="loader-container" v-show="isLoading > 0"> -->
  <div class="loader-container" v-show="false">
    <div class="loader">
      <img src="/images/smeg.svg" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      isLoading: 0,
      axiosInterceptor: null,
      blacklist: [
        {
          method: "post",
          url: "/analytics",
        },
      ],
    };
  },
  mounted() {
    this.enableInterceptor();
  },
  methods: {
    enableInterceptor() {
      this.axiosInterceptor = axios.interceptors.request.use(
        (config) => {
          if (!this.isBlacklisted(config)) {
            this.isLoading++;
            document.querySelector("body").style.overflow = "hidden";
          }
          return config;
        },
        (error) => {
          this.isLoading--;
          document.querySelector("body").style.overflow = "auto";
          return Promise.reject(error);
        }
      );

      axios.interceptors.response.use(
        (response) => {
          if (!this.isBlacklisted(response.config)) {
            this.isLoading--;
            document.querySelector("body").style.overflow = "auto";
          }
          return response;
        },
        function (error) {
          this.isLoading--;
          document.querySelector("body").style.overflow = "auto";
          return Promise.reject(error);
        }
      );
    },

    isBlacklisted(config) {
      for (let i = 0; i < this.blacklist.length; i++) {
        if (
          config.method === this.blacklist[i].method &&
          config.url.includes(this.blacklist[i].url)
        ) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style scoped>
.loader-container {
  background: grey;
}
.loader-container {
  position: fixed;
  z-index: 1002;
  top: 0;
  width: 100%;
  height: 100%;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loader {
  width: 200px;
}
</style>
<style lang="scss">
@property --a {
  initial-value: 0deg;
  inherits: false;
  syntax: "<angle>";
}
@property --h {
  initial-value: 0;
  inherits: false;
  syntax: "<number>";
}
.loader {
  padding: 2rem 4rem;
  font-family: monospace;
  font-weight: bold;
  color: #fff;
  border-style: solid;
  border-width: 1vmin;
  font-size: 2rem;
  --charge: hsl(var(--h, 0), 10%, 80%);
  -o-border-image: conic-gradient(
      var(--charge) var(--a),
      transparent calc(var(--a) + 0.5deg)
    )
    30;
  border-image: conic-gradient(
      var(--charge) var(--a),
      transparent calc(var(--a) + 0.5deg)
    )
    30;
  -webkit-animation: load 2s infinite ease-in-out;
  animation: load 2s infinite ease-in-out;
}
@-webkit-keyframes load {
  0%,
  10% {
    --a: 0deg;
    --h: 0;
  }
  100% {
    --a: 360deg;
    --h: 100;
  }
}
@keyframes load {
  0%,
  10% {
    --a: 0deg;
    --h: 0;
  }
  100% {
    --a: 360deg;
    --h: 100;
  }
}
</style>
